import { createRouter, createWebHashHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import { clearPermissionCache, ensurePermissionResourcesLoaded, getDefaultAuthorizedRouteName, hasBtnAuth, hasPageAuth } from '@/utils/auth'

const routes = [
  {
    path: '/',
    name: 'layout',
    component: () => import('@/views/Layout.vue'),
    redirect: {name: 'home'},
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home.vue'),
      },
      {
        path: '/non-key-tool',
        name: 'nonkeyTool',
        component: () => import('@/views/NonkeyTool.vue'),
      },
      {
        path: '/assets-list',
        name: 'assetsList',
        component: () => import('@/views/AssetsList.vue'),
      },
      {
        path: '/assets-check',
        name: 'assetsCheck',
        component: () => import('@/views/AssetsCheck.vue'),
      },
      {
        path: '/assets-life',
        name: 'assetsLife',
        component: () => import('@/views/AssetsLife.vue'),
      },
      {
        path: '/check-record',
        name: 'checkRecord',
        component: () => import('@/views/CheckRecord.vue'),
      },
      {
        path: '/nonkey-check-record',
        name: 'nonkeyCheckRecord',
        component: () => import('@/views/NonkeyCheckRecord.vue'),
      },
      {
        path: '/sys-user',
        name: 'sysUser',
        component: () => import('@/views/SysUser.vue'),
      },
      {
        path: '/sys-config',
        name: 'sysConfig',
        component: () => import('@/views/SysConfig/Index.vue'),
      },
      {
        path: '/personal-center',
        name: 'personalCenter',
        component: () => import('@/views/PersonalCenter.vue'),
      },
      {
        path: '/notice',
        name: 'notice',
        component: () => import('@/views/Notice.vue'),
      },
      {
        path: '/integral',
        name: 'integral',
        component: () => import('@/views/Integral.vue'),
      },
      {
        path: '/employee-feedback',
        name: 'employeeFeedback',
        component: () => import('@/views/EmployeeFeedback.vue'),
      },
      {
        path: '/sys-schedule',
        name: 'sysSchedule',
        component: () => import('@/views/SystemSchedule.vue'),
      },
      {
        path: '/asset-calibration',
        name: 'assetCalibration',
        component: () => import('@/views/AssetCalibration.vue'),
      },
      {
        path: '/asset-maintenance',
        name: 'assetMaintenance',
        component: () => import('@/views/AssetMaintenance.vue'),
      },
      {
        path: '/asset-calibration-record',
        name: 'assetCalibrationRecord',
        component: () => import('@/views/AssetCalibrationRecord.vue'),
      },
      {
        path: '/asset-maintenance-record',
        name: 'assetMaintenanceRecord',
        component: () => import('@/views/AssetMaintenanceRecord.vue'),
      },
      {
        path: '/asset-insight',
        name: 'assetInsight',
        component: () => import('@/views/AssetInsight.vue'),
      },
      {
        path: '/asset-except-report',
        name: 'assetExceptReport',
        component: () => import('@/views/AssetExceptReport.vue'),
      },
      {
        // 工具异常处理（技师等处理角色入口，复用异常上报页面，仅按权限控制菜单与按钮）
        path: '/asset-except-handle',
        name: 'assetExceptReportHandle',
        component: () => import('@/views/AssetExceptReport.vue'),
      },
      {
        path: '/asset-except-report/create',
        name: 'assetExceptReportCreate',
        meta: { pageCode: 'assetExceptReport', buttonCode: 'assetExceptReport.add' },
        component: () => import('@/views/AssetExceptReportCreate.vue'),
      },
      {
        path: '/tpm-confirm-record',
        name: 'tpmConfirmRecord',
        component: () => import('@/views/TpmConfirmRecord.vue'),
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

const WHITE_LIST = ['login']

router.beforeEach(async to => {
  const token = localStorage.getItem('wlzcToken')

  if (WHITE_LIST.includes(to.name)) {
    if (!token) return true
    const { code } = await ensurePermissionResourcesLoaded()
    if (code !== 0) return true
    const defaultRouteName = getDefaultAuthorizedRouteName()
    if (defaultRouteName && defaultRouteName !== 'login') {
      return { name: defaultRouteName }
    }
    return true
  }

  if (!token) {
    return {
      name: 'login',
      query: {
        redirect: to.fullPath
      }
    }
  }

  try {
    const { code, msg } = await ensurePermissionResourcesLoaded()
    if (code !== 0) {
      localStorage.removeItem('wlzcToken')
      clearPermissionCache()
      ElMessage.error(msg || '权限加载失败')
      return {
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      }
    }

    if (!to.name || to.name === 'layout') return true
    const pageCode = (to.meta && to.meta.pageCode) || to.name
    const buttonCode = to.meta && to.meta.buttonCode
    if (hasPageAuth(pageCode) && (!buttonCode || hasBtnAuth(buttonCode))) return true

    const fallbackRouteName = getDefaultAuthorizedRouteName()
    ElMessage.error(buttonCode ? '暂无新增权限' : '暂无访问权限')
    if (fallbackRouteName && fallbackRouteName !== to.name) {
      return { name: fallbackRouteName }
    }
    return false
  } catch (error) {
    localStorage.removeItem('wlzcToken')
    clearPermissionCache()
    ElMessage.error('权限加载失败')
    return {
      name: 'login',
      query: {
        redirect: to.fullPath
      }
    }
  }
})

export default router
